export default "__VITE_ASSET__2eIKKIyr__"